import React from 'react';
import { Text } from '../../../../../../../../CommonComponents/OPL/Text/Text';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';
import { Nodes } from './components/Nodes/Nodes';
import { Edge } from './components/Edge/Edge';
import { FlowType, useEstatePlanningFlowQuery } from '../../api/useEstatePlanningFlowQuery';
import { CustomHeader } from './FlowChart.styles';
import { Group } from './components/Group/Group';
import { FlowChartLoading } from './FlowChart.loading';
import { UserType } from '../../EstatePlanningFlow.meta';
import { ErrorState } from '../../../../../../../../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';

interface Props {
  userType: UserType;
}

export const FlowChart = ({ userType }: Props) => {
  const { data, isLoading, error, refetch } = useEstatePlanningFlowQuery({
    isSpouse: userType === UserType.Partner,
  });

  if (isLoading) {
    return <FlowChartLoading />;
  }

  if (error) {
    return <ErrorState minHeight="250px" onAction={refetch} />;
  }

  if (!data || !data.chart) {
    return null;
  }

  return (
    <Box as="section" mb="40">
      <CustomHeader mb="40">
        <Text
          fontSize="h6"
          fontWeight={600}
          mb="4"
          color="neutral.500"
          variant="tabular"
          textTransform="uppercase"
          letterSpacing="wide"
        >
          Estate planning outcomes
        </Text>
      </CustomHeader>

      {data.chart.map((flowData, flowDataIndex) => {
        const isFirst = flowDataIndex === 0;

        if (flowData.type === FlowType.Node) {
          return <Nodes key={flowDataIndex} items={flowData.items} isFirst={isFirst} />;
        }

        if (flowData.type === FlowType.Group) {
          return <Group groupItems={flowData.groupItems} key={flowDataIndex} />;
        }

        return (
          <Edge
            key={flowDataIndex}
            title={flowData.title}
            value={flowData.value}
            additionalInfo={flowData.additionalInfo}
          />
        );
      })}
    </Box>
  );
};
